/* Sight theme — variant swatch fix via event delegation.
   Garantisce che cliccando una variante (radio .field-value dentro .product-variants)
   la UI si aggiorni anche se Easify o altre app clobberano onchange o ricostruiscono il DOM. */
(function () {
	if ( window.__sightVariantDelegateInstalled ) return;
	window.__sightVariantDelegateInstalled = true;

	function moneyFormat( cents ) {
		var fmt = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active === 'EUR') ? 'EUR' : null;
		var euro = ( cents / 100 ).toFixed( 2 ).replace( '.', ',' );
		return '€' + euro;
	}

	function findSelectedVariant( picker, variants ) {
		var picks = [];
		picker.querySelectorAll( '.variant-field' ).forEach( function ( field ) {
			var radio = field.querySelector( '.field-value:checked' );
			var sel = field.querySelector( 'select.field-value' );
			if ( radio ) picks.push( radio.value );
			else if ( sel ) picks.push( sel.value );
		} );
		return variants.find( function ( v ) {
			if ( ! v.options || v.options.length !== picks.length ) return false;
			for ( var i = 0; i < picks.length; i++ ) {
				if ( String( v.options[ i ] ) !== String( picks[ i ] ) ) return false;
			}
			return true;
		} );
	}

	function updateFromPicker( picker ) {
		var wrap = picker.parentNode;
		var variantsScript = wrap && wrap.querySelector( '[data-product-variants]' );
		if ( ! variantsScript ) return;
		var variants;
		try { variants = JSON.parse( variantsScript.textContent ); } catch ( e ) { return; }
		var selected = findSelectedVariant( picker, variants );
		if ( ! selected ) return;

		var summary = picker.closest( '.product-summary' ) || picker.closest( '.shopify-section' );

		// 1. Hidden input id (usato dall'add-to-cart form).
		if ( summary ) {
			summary.querySelectorAll( 'form[action*="/cart/add"] [name="id"], input[type="hidden"][name="id"]' ).forEach( function ( inp ) {
				inp.value = selected.id;
			} );
			var innerMarker = summary.querySelector( '[data-selected-id]' );
			if ( innerMarker ) innerMarker.setAttribute( 'data-selected-id', selected.id );
		}

		// 2. Etichetta "Color: Giallo".
		picker.querySelectorAll( '.variant-field' ).forEach( function ( field ) {
			var radio = field.querySelector( '.field-value:checked' );
			var sel = field.querySelector( 'select.field-value' );
			var label = field.querySelector( '.field-title .selected-value' );
			if ( ! label ) return;
			if ( radio ) label.textContent = radio.value.trim();
			else if ( sel ) label.textContent = sel.value.trim();
		} );

		// 3. URL con ?variant=.
		var base = picker.getAttribute( 'data-url' );
		if ( base && window.history && window.history.replaceState ) {
			try {
				var u = new URL( base, window.location.origin );
				u.searchParams.set( 'variant', selected.id );
				window.history.replaceState( {}, '', u.pathname + u.search );
			} catch ( e ) {}
		}

		// 4. Prezzo — aggiorna solo se il prezzo cambia (evita di rompere markup custom).
		if ( summary ) {
			var priceEl = summary.querySelector( '.product-price' );
			if ( priceEl && typeof window.btyPriceHtml === 'function' ) {
				priceEl.innerHTML = window.btyPriceHtml( selected.price, selected.compare_at_price, selected.unit_price, selected.unit_price_measurement );
			}
		}

		// 5. Immagine in evidenza.
		var gallery = document.querySelector( '.product-gallery' );
		if ( gallery && selected.featured_media ) {
			// Swiper (layout-2)
			var swiperEl = gallery.querySelector( '.product-main-slide .swiper' );
			if ( swiperEl && swiperEl.swiper ) {
				swiperEl.swiper.slideTo( selected.featured_media.position - 1, 600 );
			} else {
				// Layout-1: scroll alla media giusta.
				var target = gallery.querySelector( '[data-id$="-' + selected.featured_media.id + '"]' );
				if ( target ) {
					var header = document.querySelector( '.header.is-sticky' );
					var offset = header ? header.offsetHeight : 0;
					var top = target.getBoundingClientRect().top + window.pageYOffset - offset - 20;
					if ( window.matchMedia( '(min-width: 992px)' ).matches ) {
						window.scrollTo( { top: top, behavior: 'smooth' } );
					}
				}
			}
		}

		// 6. Dispatcha evento canonico del tema (così chi ascolta — gallerie, sticky bar — reagisce).
		document.dispatchEvent( new CustomEvent( 'product-variant-updated', { detail: { selected: selected } } ) );
	}

	function handleChange( e ) {
		var el = e.target;
		if ( ! el || ! el.classList || ! el.classList.contains( 'field-value' ) ) return;
		var picker = el.closest( '.product-variants' );
		if ( ! picker ) return;
		updateFromPicker( picker );
	}

	// Capture:true per scavalcare eventuali stopPropagation di app (Easify).
	document.addEventListener( 'change', handleChange, true );

	// Fallback: alcuni browser/app preferiscono 'click' su label. Triggeriamo in ritardo 0 così
	// il radio sottostante ha già preso il checked.
	document.addEventListener( 'click', function ( e ) {
		var label = e.target.closest && e.target.closest( '.product-variants label' );
		if ( ! label ) return;
		setTimeout( function () {
			var picker = label.closest( '.product-variants' );
			if ( picker ) updateFromPicker( picker );
		}, 0 );
	}, true );
} )();
